module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "pro"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cdl"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("New Year’s Eve")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("The boy awoke to his father’s scream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Somewhere in the darkness down the hall, behind his parents’ bedroom door, his father cried out as if his world was suddenly undone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was terror and rage and pain in that scream and, before the boy was fully awake, he was out of bed and opening his door just a crack, just enough to stare down the dark landing to the closed bedroom door where now there was only silence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘Dad?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He stood, staring into the darkness, the only sounds his ragged breathing and the drunken voices that drifted up from the city streets, celebrating the death of another year.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A bell tolled at the back of the house, moved by the wind, the deep resonant sound of the temple bell in his mother’s garden, tolling as if to mark the end of all things.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And from behind the bedroom door at the end of the hall, his mother began to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And when at last she stopped, his father began to sob as though his heart had been broken.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Terror and shock choked in the boy’s throat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His kind, calm father, with his slow easy smile and his air of amusement, a father who never raised his voice, let alone his hand, sobbing as if everything he loved was being taken away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he heard a voice that he did not know.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Insistent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Inhuman.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Tight with fury.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘I’ll not tell you again,’ the voice commanded. ‘I want you to watch.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then sounds that made no sense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A sound like wood being chopped. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Chunk … chunk … chunk")]), _vm._v(" … And accompanying the low moans of misery from the bedroom down the hall came the drunken cheers of the revellers in the other world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("None of it seemed real.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The boy slumped against the door, his breath coming in shallow gasps, suddenly aware of the tears streaming down his face.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Somewhere in their home the dog began to bark, and the familiar noise, that unexpected reminder of a world he understood, made him move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He slipped out of his bedroom, his heart hammering and his legs heavy and a slick film of terrified sweat covering his body.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He moved quickly away from the terrible sounds, down the landing to his sister’s bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He went inside and found her sitting on her bed, fully dressed in her party clothes, dry-eyed, her face white with shock as she fumbled for her phone and punched "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("9")]), _vm._v(" once.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They both looked up at the sudden eruption of violence coming from the bedroom down the hall. Unknown, unknowable sounds. A struggle of terrible ferocity, flesh and bone colliding with walls and floor. Dull thuds and muffled groans.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The sound of something fighting for its life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He saw his sister punch another "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("9.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He closed his eyes, dizzy with sickness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This would end. He would wake up and the nightmare would be over. But he opened his eyes and it was more real than anything he had ever known.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister’s hands were shaking as she punched the third and final "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("9.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dog was barking furiously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And then there were heavy footsteps coming down the hall, no attempt at stealth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Coming for them now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘The door!’ his sister hissed and the boy reached it and locked it in one desperate motion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he stepped back, staring at the locked door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Somebody was knocking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("A gentle, almost playful tap with the knuckle of the index finger.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked at his sister.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The door seemed to press against its frame as if it was being tested by a powerful shoulder. Then the wood shattered and splintered and cracked as the kicking began.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Emergency services – how may I direct your call?")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘Please,’ the girl said. ‘We need help.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the boy was at the window, opening it, freezing air rushing in and with it the sound of distant music, parties, laughter drifting across the final few minutes of the year’s last day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked back as the door caved in and a dark figure loomed in the hallway, reaching through the shattered wood for the key he had left in the lock.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It did not look like a man.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The figure in the doorway seemed like some deeper darkness and as it came into the bedroom, the boy could smell him, the sickening scent of sweat and blood and sex and the kind of industrial stink that reeked of old cars and dead engines and puddles of grease.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a voice in the room coming from his sister’s phone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("‘Hello? How may I direct your call? Hello?’")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he was suddenly falling, dropping through the cold air and almost immediately hitting the driveway below with a grunt of pain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He looked up at the first-floor window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister had one leg out of the window and one leg still in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dark figure must have got her by the neck, because she was clearly choking, yes, the boy saw it now, thick fingers were wrapped around the chain on her necklace, twisting it in his fist, the way you twist the collar of a dangerous dog.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The black figure was trying to strangle her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then the necklace must have snapped because she was falling through the air sideways for what felt like a long second and he stepped quickly back as the ground rushed up to hit her hard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he was helping his sister to her feet and she was struggling to walk, something wrong with one of her knees as they went out into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They lived in a gated community at the highest point of the city, six large houses behind a tall iron gate and high brick walls that were topped with discreet razor wire.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("All of London fell away beneath them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It felt like the top of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He left his sister in the middle of the street, rubbing her bloody knees, and ran across the road to the nearest house, leaning on their doorbell, screaming for help, shouting about murder.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the house was in darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And he saw that most of the other houses in that exclusive community were in darkness too. There was only one house at the very end of the road that was ablaze with light and noise. The boy ran towards it and banged on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But the music was too loud and they were getting ready for midnight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And he heard happy drunken voices in a babble of languages.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Polish. Tagalog. Spanish. Italian. Punjabi. And broken English.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The owners were away and the help were having a party.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And the help didn’t hear him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then his sister was coming towards him, hobbling badly, only putting her full weight on one foot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("They both looked up as a firework exploded in the sky. In the distance, people cheered, suddenly much drunker and much happier. They both stared back at their home.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And from somewhere deep inside that house, a small child began to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The boy cursed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘We can’t leave him,’ his sister said. ‘Can you smell it?’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There was a smell of burning, of smoke and gunpowder and the flames to come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘It’s fireworks,’ he said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘He’s burning our home.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He saw it now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Black smoke drifted from a ground-floor window.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘You go,’ she said. ‘Get help. I’ll get the little one.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He wiped his face and choked down a thick knot of bile as his sister began to stumble back to the burning house. The smoke was already thicker, the voices of the party people were suddenly raised, and he found he could not move.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("TEN!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("His sister turned to look at him just once, her face white in the moonlight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("NINE!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He watched her hobble up the drive, limping round the side of the house. And he knew with total certainty that he would never see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("EIGHT!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He shivered with cold and fear. And tried to think.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("SEVEN!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He could still hear the celebrations at the house with all the lights and noise and laughter, but they seemed very far away now, removed from anything he understood, from anything that made any kind of sense.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("SIX!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He screamed, panic and frustration overwhelming him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("FIVE!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Nobody heard. Nobody cared. He was completely alone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("FOUR!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("From the highest hill in London he saw bursts of colour and sound start to blaze and pop and explode across the city sky. It was beautiful, like a jewel box being emptied across the heavens by some careless god.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And he knew that he could do this thing. He would go beyond the iron gates that were there to keep out the wicked and the poor and he would run down the hill and find help. That is what he would do. And the nightmare would end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("THREE!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their dog was barking again and the smoke was thicker still. He could not see his sister. His family were relying on him now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("TWO!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He began to run towards the iron gates.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("ONE!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the New Year dawned and the sky exploded high above him, the car smashed into him, hitting him low on the back of the legs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("HAPPY NEW YEAR!")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The car was going very fast and knocked him backwards across the hood then immediately threw him forward, the rear wheels passing over his legs and reducing them to a bloody mush of crushed flesh and pulped bone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Somewhere people were cheering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Then he was lying on his back and staring up at a midnight sky that was brighter than daylight, the colours everywhere all at once, yellows and reds and whites and greens erupting among the stars and then drifting to earth, and it was very peaceful lying there watching the sky until the pain came to claim him, the kind of pain that makes you empty your stomach, and the boy felt the reality of his ruined legs, and the agony was more than he could stand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He watched the fireworks set the night ablaze without seeing them because now he could think of nothing but the pain. He heaved up a thick wad of blood as a dark figure bent above him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("‘Please,’ the boy said. ‘Help me.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The dark figure lifted him up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("With strong hands. Kind hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The boy wasn’t sure if that was the right thing to do. He wasn’t sure if he should be moved. Perhaps that wasn’t the best thing. But he felt weak with gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Until he smelled that same stinking cocktail of stale sweat and used grease, both mechanical and human.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Until he saw that the hands and arms that held him as if he weighed nothing were drenched in the lifeblood of his family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The fireworks above London were a riot of colour now.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But as he was carried back to what remained of his family, the boy surrendered gladly to the blackness, and he did not see them explode with light, and he did not see them die.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 75
// module chunks = 0